<div id="osContainer" class=container1>

    <div id="osFactTagInfo" class="main-content paddingSection">
        <div id="ftags" class="fact_tags mt-3 clr-white">{{os}}</div>
    </div>

</div>